export default __webpack_public_path__ + "2314b37685d40b3d57da911bd1e4251a.png";